import { IncomingMessage } from 'http';
import { parse } from 'url';
import nookies from 'nookies';
import uuid from 'uuid/v4';

import { getClientIp } from '@/server/utils/getClientIp';
import initBrowserLanguage from '@/server/utils/initBrowserLanguage';

import { getCookie, setCookie } from '../cookies';
import { getUserToken } from './getUserTokenFromRequest';
import { RequestUserData } from './types';

export function getUserData({
	req,
	deviceId,
	calmIdentifier,
	calmUserToken,
	platform,
}: {
	req?: IncomingMessage;
	deviceId?: string;
	calmIdentifier?: string;
	calmUserToken?: string;
	platform?: 'www' | 'msft-teams';
} = {}): RequestUserData {
	if (req) {
		const cookies = nookies.get({ req });
		const userToken = getUserToken(cookies, req, calmUserToken);
		const userIp = getClientIp(req);
		const browserLanguage = initBrowserLanguage(req);
		const { pathname } = typeof req.url === 'string' ? parse(req.url, true) : { pathname: undefined };

		return {
			deviceId,
			calmIdentifier,
			userToken,
			userIp,
			browserLanguage,
			platform,
			cookies,
			path: pathname,
		};
	}

	const deviceIdCookieValue = getCookie('x-device-id');
	const userToken = getCookie('calm-user-token');
	const calmId = getCookie('calm-id');
	const newDeviceId = deviceIdCookieValue || uuid();
	if (newDeviceId !== deviceIdCookieValue) {
		setCookie('x-device-id', newDeviceId);
	}

	return {
		deviceId: newDeviceId,
		userToken,
		calmIdentifier: calmId,
		path: window?.location?.href,
		cookies: undefined,
	};
}
